import 'vue/jsx'

// 引入unocss
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// 路由
import { setupRouter } from './router'

import { createApp } from 'vue'

import App from './App.vue'

import './permission'

const now = new Date().getTime()
const leaveTimeTmp = localStorage.getItem('leaveTime')
if (leaveTimeTmp) {
  const leaveTime = parseInt(leaveTimeTmp, 10)
  const refresh = now - leaveTime <= 5000
  // over 5sec will be considered as opening browser, so clear user info
  if (!refresh) {
    const userString = localStorage.getItem('user')
    if (userString) {
      const user = JSON.parse(userString)
      user.token = ''
      user.owUserInfo = ''
      localStorage.setItem('user', JSON.stringify(user))
    }
  }
}
localStorage.removeItem('leaveTime')

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setupRouter(app)

  app.mount('#app')
}

setupAll()

// F5 refresh or close browser will trigger this
window.onbeforeunload = () => {
  localStorage.setItem('leaveTime', new Date().getTime().toString())
}
